import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  CampaignNotificationPopupService,
  type CampaignPopupItem,
} from '../../../core/services/notification/campaign-notification-popup.service';
import { NotificationService } from '../../../core/services/notification/notification.service';
import { CAMPAIGN_RUNTIME_ALERT_META } from '../../notification/notification-ui.utils';

@Component({
  selector: 'app-campaign-notification-popup',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './campaign-notification-popup.component.html',
  styleUrl: './campaign-notification-popup.component.css',
})
export class CampaignNotificationPopupComponent {
  readonly popupService = inject(CampaignNotificationPopupService);
  private readonly notificationService = inject(NotificationService);
  private readonly router = inject(Router);

  trackById(_index: number, item: CampaignPopupItem): string {
    return item.id;
  }

  categoryLabel(item: CampaignPopupItem): string {
    if (item.alertKind) {
      return CAMPAIGN_RUNTIME_ALERT_META[item.alertKind].title;
    }
    return 'Campaign Alert';
  }

  dismiss(id: string, ev: Event): void {
    ev.preventDefault();
    ev.stopPropagation();
    this.popupService.dismiss(id);
  }

  async onPopupClick(item: CampaignPopupItem): Promise<void> {
    if (item.notificationId) {
      await this.notificationService.markAsRead(item.notificationId);
    }
    if (item.campaignId) {
      void this.router.navigate(['/marketing/campaigns', item.campaignId]);
    } else {
      void this.router.navigate(['/notification-center']);
    }
    this.popupService.dismiss(item.id);
  }
}
